export default __webpack_public_path__ + "static/img_2-abf853dad5a76d4d4eb7a451b1c69b3b.png";